var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 55,
    viewBox: "0 0 70 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4338 48.8246H18.3717L20.6589 46.529H52.4338C60.866 46.529 67.7017 39.6933 67.7017 31.2611C67.7017 22.8289 60.866 15.9932 52.4338 15.9932H52.0727H51.0831L53.3471 13.721C62.6227 14.1961 69.9973 21.8674 69.9973 31.2611C69.9973 40.9612 62.1339 48.8246 52.4338 48.8246ZM34.9987 2.29558C40.2525 2.29558 44.8907 4.9741 47.6226 9.05078L49.2701 7.39718C46.0987 2.92042 40.8885 0 34.9987 0C26.6574 0 19.6792 5.85742 17.9246 13.6976H17.5635C7.86344 13.6976 0 21.5611 0 31.2611C0 38.1719 3.9914 44.1505 9.7947 47.0174L11.5197 45.2861C6.09352 42.9446 2.29558 37.5464 2.29558 31.2611C2.29558 22.8289 9.13125 15.9932 17.5635 15.9932H17.9246H19.7632L20.1648 14.199C21.691 7.37933 27.7606 2.29558 34.9987 2.29558ZM8.40821 52.0281C7.89367 52.5445 7.89367 53.3818 8.40821 53.8982C8.92274 54.4146 9.75696 54.4146 10.2715 53.8982L60.4419 3.54385C60.9564 3.02743 60.9564 2.19015 60.4419 1.67373C59.9273 1.15731 59.0931 1.15731 58.5786 1.67373L8.40821 52.0281Z",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineDevice);
export default __webpack_public_path__ + "static/media/OfflineDevice.88749535d40e25d1921bae6d6672d776.svg";
export { ForwardRef as ReactComponent };